import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedTopicsView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/topic/applied_topics"]
  name: 'topics'
  events:
    "click #edit_topics": "onEdit"
    "click #more-less": "_toggleMoreLessText"

  onEdit: =>
    @eventAggregator.trigger('editTopics')

  _toggleMoreLessText: (event) =>
    element = $(event.currentTarget)
    if element.hasClass('topics_show_more')
      element.removeClass('topics_show_more').addClass('topics_show_less')
      element.text(I18n.t('monitoring.dashboard.applied_filters.show_less'))
      @$el.find('.hidden-topics').removeClass('hidden')
    else
      element.removeClass('topics_show_less').addClass('topics_show_more')
      element.text(I18n.t('monitoring.dashboard.applied_filters.show_more'))
      @$el.find('.hidden-topics').addClass('hidden')

  appliedTopics: =>
    appliedTopics = _.map(@getAppliedValues(), (value) => { name: value.name, icon: @iconForSource(value.sources) } )
    if appliedTopics.length == 0
      appliedTopics.push({ name: I18n.t('monitoring.dashboard.all_topics'), icon: '' })
    sortedTopics = _.sortBy(appliedTopics, (topic) -> topic.name)
